import ProductRecommendationsInstallPrompt from 'components/ProductRecommendationsInstallPrompt'
import SlideInWrapper from 'components/SlideInWrapper'
import { ProductRecommendationsForm } from 'components/forms/ProductRecommendationsForm'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'

function ProductRecommendations() {
	useSectionOpenedTracking()
	return (
		<SlideInWrapper>
			<ProductRecommendationsInstallPrompt />
			<ProductRecommendationsForm />
		</SlideInWrapper>
	)
}

export default ProductRecommendations
